import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

const SignOutForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  return (
    <div className="text-center mb-6 mx-auto">
      <div className="mb-6">
        <h4 className="text-1000">Volte logo!</h4>
        <p className="text-700">
          Obrigado por usar o RoadMarker.
          <br />
          Você foi deslogado com sucesso.
        </p>
      </div>
      <div className="d-grid">
        <Button
          variant="primary"
          as={Link}
          to={`/pages/authentication/${layout}/sign-in`}
          startIcon={<FontAwesomeIcon icon={faAngleLeft} className="me-2" />}
        >
          Entrar novamente
        </Button>
      </div>
    </div>
  );
};

export default SignOutForm;
